function DazProductList(api, rawCatalogData) {
    // This is a direct list of all product id's
    this.productList = [];
    this.productCount = -1;
    // used when filtering categories
    this.originalProductList = [];
    this.selectedFilters = [];

    // toggle layouts until old is completely removed
    this.layout = 'new'

    // The ordered list of product id's in the category
    // this is manipulated by the filter/order functions
    this.ordered = [];
    // The offset to start on in the ordered list
    this.orderedStart = 0;
    // Used for determining the "new flag"
    this.now = Math.floor(new Date().getTime()/1000);

    // The index in the "ordered" list to what element is in the top left
    this.topLeftIndex = null;

    // A cache of the product positions
    this.positionCache = {};

    // An element to store the scrollTimeout timeout to make sure there
    // is some delay before processing scroll events
    this.scrollTimeout = null;

    // Which filters the user has applied
    this.filterSettings = {owned: true};
    this.priceFilterDefaults = {min: 0, max: 0};
    this.priceFilterDebounce = null;
    this.filterVisibleLimit = 5;
    this.filterCountGeneration = 0;
    // Bonus data to show which filters are open/closed
    // And which ones need to be loaded
    this.filterData = {};

    // The sort order settings
    this.sortOrderSettings = ['date',1];

    // If we need to scroll to an element, we have to wait for the element to load
    this.scrollToCallback = null;

    // If we are doing infinite scrolling
    this.infiniteScroll = false;

    // How many items per page
    this.pageSize = 60;

    // Which page are we currently on
    this.currPage = 0;

    // Are we the reason the hash changed?
    this.changingHash = false;

    // Templates for various actions
    this.slabholder = Templates.slabholder;
    this.slab = Templates.slab;

    // For when pagination has an input field to enter go-to-page number
    this.$paginationContainer = $('.pagination_container');
    this.$controlsContainer = this.$paginationContainer.find('.controls_container');
    this.$goToPageContainer = this.$paginationContainer.find('.go_to_page_container');
    this.$goToPageInput = this.$paginationContainer.find('.go_to_page_input');
    if (!this.$goToPageInput.length) {
        this.$goToPageInput = this.$goToPageContainer.find('input');
    }
    this.lastPagenum = 1;
    this.paginationTransitionSpd = 200;
    this.goToPageTimeout = null;
}

/*** INIT FUNCTIONS ***/
DazProductList.prototype.init = function(listElem, rawCatalogData) {
    this.listElem = listElem;

    if (typeof(rawCatalogData) == 'object' ) {
        // Load in the passed in data
        for (var i = 0; i < rawCatalogData.length; i++) {
            var productId = rawCatalogData[i];
            this.productList.push(productId);
        }

        this.categoryId = null;
    } else {
        this.categoryId = rawCatalogData;
    }

    var pageSizeSetting = daz.api.storageGet('catalog_pageSize');
    if (pageSizeSetting != null) {
        this.pageSize = pageSizeSetting;
        this.infiniteScroll = pageSizeSetting == -1;
    }

    $('.pagesize').val(this.pageSize);
    $('.pagesize').on('change', $.proxy(this.changePageSize, this));
    $('.pagination').on('click', $.proxy(this.handlePaginationClick, this));
    $('.pagination_container .prev').on('click', $.proxy(this.handlePaginationPrev, this));
    $('.pagination_container .next').on('click', $.proxy(this.handlePaginationNext, this));

    if (this.$controlsContainer.length) {
        $('.pagination').on('click', '.pagination_blank', $.proxy(this.handlePaginationBlankClick, this));
        this.$controlsContainer.find('.back_to_top').on('click', () => $("html, body").animate({ scrollTop: $('#top-header').offset().top - 120 }));
        
        window.addEventListener('scroll', this.handleShowHideBackToTop.bind(this))
    }
    
    if (this.$goToPageInput.length) {
        this.$goToPageInput.on('keydown', $.proxy(this.handlePaginationGoToPageKeydown, this));
        this.$goToPageInput.on('change', $.proxy(this.handlePaginationGoToPageChange, this));
    }


    
    this.listElem.on('click',$.proxy(this.handleClick, this));

    $(document).on('debounced-resize', $.proxy(this.handleResize,this));
    window.addEventListener("hashchange", $.proxy(this.handleHashChange, this), false);

    this.reinit();
};

DazProductList.prototype.reinit = function() {
    this.catalogReady = false;
    this.urlHash = $.url(window.location.hash);

    this.showLoading();
    daz.filter.onLoad(this, this.showCatalog);
};

DazProductList.prototype.handleHashChange = function() {
    if (this.changingHash) {
        return;
    }

    this.reinit();
};

DazProductList.prototype.reset = function() {
    this.listElem[0].innerHTML = '';
    this.orderedStart = 0;
    this.positionCache = {};
    this.topLeftIndex = null;
    this.pageNum = 0;
};

DazProductList.prototype.showLoading = function() {
    if (this.showingLoading) {
        return;
    }
    this.showingLoading = true;
    if (daz.loading) {
        daz.loading.show('#catalog-loading');
    } else {
        $('#catalog-loading').fadeIn(150);
    }
};

DazProductList.prototype.hideLoading = function() {
    if (!this.showingLoading || this.filterLoadingActive) {
        return;
    }
    this.showingLoading = false;
    if (daz.loading) {
        daz.loading.hide('#catalog-loading');
    } else {
        $('#catalog-loading').fadeOut(150);
    }
};

DazProductList.prototype.showFilterLoading = function() {
    this.filterApplyToken = (this.filterApplyToken || 0) + 1;
    this.filterLoadingActive = true;
    if (daz.loading) {
        daz.loading.show('#catalog-loading');
    } else {
        $('#catalog-loading').stop(true, true).fadeIn(150);
    }
    return this.filterApplyToken;
};

DazProductList.prototype.hideFilterLoading = function(token) {
    if (token && token !== this.filterApplyToken) {
        return;
    }
    this.filterLoadingActive = false;
    if (this.showingLoading) {
        return;
    }
    if (daz.loading) {
        daz.loading.hide('#catalog-loading');
    } else {
        $('#catalog-loading').stop(true, true).fadeOut(150);
    }
};

DazProductList.prototype.waitForSlabsToFinish = function(onDone) {
    var attempts = 0;
    var self = this;

    (function check() {
        attempts += 1;
        var pendingSlabs = typeof DazProductSlab !== 'undefined' && DazProductSlab.requestCount > 0;
        var pendingScroll = !!self.scrollTimeout;
        if (!pendingSlabs && !pendingScroll) {
            onDone();
            return;
        }
        if (attempts < 120) {
            window.setTimeout(check, 50);
            return;
        }
        onDone();
    })();
};

DazProductList.prototype.formatFilterCount = function(count) {
    count = parseInt(count, 10);
    if (isNaN(count)) {
        count = 0;
    }
    return count.toLocaleString('en-US');
};

DazProductList.prototype.getSelectedFilterValues = function(filterType) {
    if (!this.filterSettings[filterType] || typeof this.filterSettings[filterType] != 'object') {
        return [];
    }
    return this.filterSettings[filterType];
};

DazProductList.prototype.isFilterValueSelected = function(filterType, value) {
    var selected = this.getSelectedFilterValues(filterType);
    if (filterType === 'file_formats') {
        var target = (value || '').trim().toUpperCase();
        for (var i = 0; i < selected.length; i++) {
            if ((selected[i] || '').trim().toUpperCase() === target) {
                return true;
            }
        }
        return false;
    }
    return selected.indexOf(value) !== -1;
};

DazProductList.prototype.verifySelectedFileFormatsInDom = function() {
    var filterType = 'file_formats';
    var filterData = this.filterData[filterType];

    if (!filterData || !filterData.elemNew || !filterData.elemNew.length) {
        return false;
    }

    var selectedValues = this.getSelectedFilterValues(filterType);
    if (!selectedValues.length) {
        return false;
    }

    if (daz.filter && daz.filter.normalizeFileFormatFilterValues) {
        selectedValues = daz.filter.normalizeFileFormatFilterValues(selectedValues);
    }

    var self = this;
    var missingSelected = selectedValues.some(function(idx) {
        return !document.getElementById(self.filterGetId('large', filterType, idx));
    });

    if (!missingSelected) {
        return false;
    }

    filterData.sorted = false;
    this.sortFilter(filterType);
    return true;
};

DazProductList.prototype.getPriceFilterBounds = function() {
    var maxPrice = 0;

    if (typeof(dazPricing) == 'undefined') {
        return {min: 0, max: 0};
    }

    for (let i = 0; i < this.productList.length; i++) {
        const price = parseInt(dazPricing[this.productList[i]], 10);
        if (!isNaN(price) && price > maxPrice) {
            maxPrice = price;
        }
    }

    return {
        min: 0,
        max: Math.ceil(maxPrice / 100) * 100
    };
};

DazProductList.prototype.clampPriceValue = function(value) {
    value = parseInt(value, 10);
    if (isNaN(value)) {
        value = 0;
    }
    value = Math.max(this.priceFilterDefaults.min, value);
    value = Math.min(this.priceFilterDefaults.max, value);
    return value;
};

DazProductList.prototype.getCurrentPriceFilter = function() {
    let minPrice = this.priceFilterDefaults.min;
    let maxPrice = this.priceFilterDefaults.max;

    if (this.filterSettings.price && this.filterSettings.price.length >= 2) {
        minPrice = this.clampPriceValue(this.filterSettings.price[0]);
        maxPrice = this.clampPriceValue(this.filterSettings.price[1]);
    }

    if (minPrice > maxPrice) {
        const tmp = minPrice;
        minPrice = maxPrice;
        maxPrice = tmp;
    }

    return {min: minPrice, max: maxPrice};
};

DazProductList.prototype.isPriceFilterActive = function() {
    if (!this.filterSettings.price || this.filterSettings.price.length < 2) {
        return false;
    }

    const current = this.getCurrentPriceFilter();
    return current.min !== this.priceFilterDefaults.min || current.max !== this.priceFilterDefaults.max;
};

DazProductList.prototype.getActiveFilterCount = function() {
    let filterTotal = 0;

    for (let filterName in this.filterSettings) {
        if (filterName === 'owned') {
            continue;
        }
        if (filterName === 'price') {
            filterTotal += this.isPriceFilterActive() ? 1 : 0;
        } else if (typeof this.filterSettings[filterName] == 'object') {
            filterTotal += this.filterSettings[filterName].length;
        } else if (this.filterSettings[filterName]) {
            filterTotal++;
        }
    }

    if (daz.filter.filters.shopCategoriesWhitelist) {
        filterTotal += Object.keys(daz.filter.filters.shopCategoriesWhitelist).length;
    }

    return filterTotal;
};

DazProductList.prototype.setPriceFilter = function(minPrice, maxPrice, applyNow, syncOptions) {
    minPrice = this.clampPriceValue(minPrice);
    maxPrice = this.clampPriceValue(maxPrice);

    if (minPrice > maxPrice) {
        maxPrice = minPrice;
    }

    if (minPrice === this.priceFilterDefaults.min && maxPrice === this.priceFilterDefaults.max) {
        delete this.filterSettings.price;
    } else {
        this.filterSettings.price = [minPrice, maxPrice];
    }

    this.syncPriceFilterUI(syncOptions);

    if (applyNow) {
        this.applyFilters(true);
        this.handleClick(true);
    }
};

DazProductList.prototype.syncPriceFilterUI = function(syncOptions) {
    syncOptions = syncOptions || {};
    const $container = $('#priceFilterContainer');
    if (!$container.length) {
        return;
    }

    const current = this.getCurrentPriceFilter();
    const maxBound = this.priceFilterDefaults.max;
    const disabled = maxBound <= 0;

    const $minRange = $('#price-min-range');
    const $maxRange = $('#price-max-range');
    const $minInput = $('#price-min-input');
    const $maxInput = $('#price-max-input');

    $minRange.attr({min: this.priceFilterDefaults.min, max: maxBound}).prop('disabled', disabled);
    $maxRange.attr({min: this.priceFilterDefaults.min, max: maxBound}).prop('disabled', disabled);
    $minInput.attr({min: 0, max: Math.round(maxBound / 100)}).prop('disabled', disabled);
    $maxInput.attr({min: 0, max: Math.round(maxBound / 100)}).prop('disabled', disabled);

    if (!syncOptions.skipRangeValues) {
        $minRange.val(current.min);
        $maxRange.val(current.max);
    }

    $minInput.val(Math.round(current.min / 100));
    $maxInput.val(Math.round(current.max / 100));

    const range = maxBound - this.priceFilterDefaults.min;
    const minPct = range > 0 ? ((current.min - this.priceFilterDefaults.min) / range) * 100 : 0;
    const maxPct = range > 0 ? ((current.max - this.priceFilterDefaults.min) / range) * 100 : 100;

    $container.find('.price-range-selected').css({
        left: minPct + '%',
        right: (100 - maxPct) + '%'
    });

    $container.toggleClass('price-filter-active', this.isPriceFilterActive());
    $container.toggleClass('price-filter-empty', disabled);
};

DazProductList.prototype.initPriceFilter = function() {
    if (!$('#priceFilterContainer').length) {
        return;
    }

    this.priceFilterDefaults = this.getPriceFilterBounds();

    if (!this.filterSettings.price) {
        this.setPriceFilter(this.priceFilterDefaults.min, this.priceFilterDefaults.max, false);
    } else {
        const current = this.getCurrentPriceFilter();
        this.setPriceFilter(current.min, current.max, false);
    }

    $('#price-min-range, #price-max-range').off('.dazPriceFilter').on('input.dazPriceFilter change.dazPriceFilter', $.proxy(this.handlePriceRangeChange, this));
    $('#price-min-input, #price-max-input').off('.dazPriceFilter').on('input.dazPriceFilter change.dazPriceFilter', $.proxy(this.handlePriceInputChange, this));
    $('.price-range-control').off('click.dazPriceFilter').on('click.dazPriceFilter', $.proxy(this.handlePriceTrackClick, this));
};

DazProductList.prototype.handlePriceRangeChange = function(event) {
    window.clearTimeout(this.priceFilterDebounce);

    let minPrice = parseInt($('#price-min-range').val(), 10);
    let maxPrice = parseInt($('#price-max-range').val(), 10);

    if (event && event.target) {
        if (event.target.id === 'price-min-range' && minPrice > maxPrice) {
            minPrice = maxPrice;
            $('#price-min-range').val(minPrice);
        } else if (event.target.id === 'price-max-range' && maxPrice < minPrice) {
            maxPrice = minPrice;
            $('#price-max-range').val(maxPrice);
        }
    }

    this.setPriceFilter(minPrice, maxPrice, false, {skipRangeValues: true});
    this.priceFilterDebounce = window.setTimeout($.proxy(function() {
        this.applyFilters(true);
        this.handleClick(true);
    }, this), 500);
};

DazProductList.prototype.handlePriceTrackClick = function(event) {
    if ($(event.target).is('.price-range-input')) {
        return;
    }

    const maxBound = this.priceFilterDefaults.max;
    const minBound = this.priceFilterDefaults.min;
    const range = maxBound - minBound;

    if (range <= 0) {
        return;
    }

    const current = this.getCurrentPriceFilter();
    const track = $(event.currentTarget).find('.price-range-track')[0];

    if (!track) {
        return;
    }

    const trackRect = track.getBoundingClientRect();
    if (trackRect.width <= 0) {
        return;
    }

    const clickX = Math.max(0, Math.min(event.clientX - trackRect.left, trackRect.width));
    const step = parseInt($('#price-max-range').attr('step'), 10) || 100;
    const rawValue = minBound + ((clickX / trackRect.width) * range);
    const clickedPrice = this.clampPriceValue(minBound + (Math.round((rawValue - minBound) / step) * step));

    if (clickedPrice < current.min) {
        this.setPriceFilter(clickedPrice, current.max, true);
    } else if (clickedPrice > current.max) {
        this.setPriceFilter(current.min, clickedPrice, true);
    }
};

DazProductList.prototype.handlePriceInputChange = function(event) {
    window.clearTimeout(this.priceFilterDebounce);

    let minPrice = parseInt($('#price-min-input').val(), 10) * 100;
    let maxPrice = parseInt($('#price-max-input').val(), 10) * 100;

    if (event && event.target) {
        if (event.target.id === 'price-min-input' && minPrice > maxPrice) {
            minPrice = maxPrice;
        } else if (event.target.id === 'price-max-input' && maxPrice < minPrice) {
            maxPrice = minPrice;
        }
    }

    this.setPriceFilter(minPrice, maxPrice, false);
    this.priceFilterDebounce = window.setTimeout($.proxy(function() {
        this.applyFilters(true);
        this.handleClick(true);
    }, this), 250);
};

DazProductList.prototype.resetPriceFilter = function() {
    this.setPriceFilter(this.priceFilterDefaults.min, this.priceFilterDefaults.max, false);
};

DazProductList.prototype.updateSectionToggleAria = function(filterType, expanded) {
    const elemNew = this.filterData[filterType] && this.filterData[filterType].elemNew;
    if (!elemNew || !elemNew.length) {
        return;
    }
    $('[data-toggleelem="#' + elemNew.attr('id') + '"]').attr('aria-expanded', expanded ? 'true' : 'false');
};

DazProductList.prototype.refreshFilterListVisibility = function(filterType) {
    const data = this.filterData[filterType];
    if (!data || !data.elemNew || !data.elemNew.length) {
        return;
    }

    const $container = data.elemNew;
    const isCategory = filterType === 'shopCategories';
    const isFileFormat = filterType === 'file_formats';
    const $list = isCategory ? $container.find('ul.outer-ul').first() : $container.find('ul.products-list').first();
    const $items = isFileFormat
        ? $container.find('ul.products-list[data-format-group] > li.js-filter-option-container').not('.li-template')
        : $list.children('li.js-filter-option-container').not('.li-template').not('.li-template-outer').not('.li-template-inner');
    const $search = $container.find('input.filter_search');
    const searchTerm = ($search.val() || '').toLowerCase();
    const expanded = $container.attr('data-show-all') === 'true';
    const limit = isFileFormat ? 9999 : this.filterVisibleLimit;
    const currentCountGeneration = parseInt($container.attr('data-filter-count-generation'), 10);
    let matchedCount = 0;
    let shownCount = 0;
    const self = this;

    $items.each(function(idx, elem) {
        const $elem = $(elem);
        const filterVal = $elem.attr('data-filterval');
        const checked = $elem.find('input[type="checkbox"]').filter(':checked').length > 0;
        const isSelected = checked || self.isFilterValueSelected(filterType, filterVal);
        const rowCountGeneration = parseInt($elem.attr('data-filter-count-generation'), 10);
        const hasCurrentCount = !isNaN(currentCountGeneration) && rowCountGeneration === currentCountGeneration;
        const empty = hasCurrentCount && parseInt($elem.attr('data-filter-count'), 10) === 0;
        const matchesSearch = !searchTerm || elem.textContent.toLowerCase().indexOf(searchTerm) !== -1 || isSelected;

        if (!matchesSearch || (empty && !isSelected)) {
            $elem.hide().removeClass('filter_visible');
            return;
        }

        matchedCount++;

        if (!expanded && shownCount >= limit && !isSelected) {
            $elem.hide().removeClass('filter_visible');
            return;
        }

        if (isSelected && !$elem.find('input[type="checkbox"]').prop('checked')) {
            $elem.find('input[type="checkbox"]').prop('checked', true);
            $elem.addClass('filter-option-selected');
        }

        shownCount++;
        $elem.show().addClass('filter_visible');
    });

    const $button = $container.find('.filter-show-more');
    if (!$button.length || isFileFormat || searchTerm || matchedCount <= limit) {
        $button.prop('hidden', true);
    } else {
        $button.prop('hidden', false).text(expanded ? 'Show less' : 'Show more');
    }

    if (isFileFormat && daz.filter.updateFileFormatGroupVisibility) {
        daz.filter.updateFileFormatGroupVisibility($container[0]);
    }
};

DazProductList.prototype.handleShowMoreClick = function(event) {
    event.preventDefault();
    const filterType = $(event.currentTarget).attr('data-filtertype');
    const data = this.filterData[filterType];
    if (!data || !data.elemNew) {
        return;
    }

    const expanded = data.elemNew.attr('data-show-all') === 'true';
    data.elemNew.attr('data-show-all', expanded ? 'false' : 'true');
    if (expanded) {
        this.refreshFilterListVisibility(filterType);
    } else {
        this.filterCountGeneration++;
        this.updateFilterCountsForType(filterType, true, this.filterCountGeneration);
    }
};

DazProductList.prototype.updateSelectedCategoryCount = function() {
    const whitelist = daz.filter.filters.shopCategoriesWhitelist || {};
    const selectedCount = Object.keys(whitelist).length;
    $('#selected-cat-count').text(selectedCount ? '(' + selectedCount + ')' : '');
};

DazProductList.prototype.updateCategoryProductList = function() {
    const whitelist = daz.filter.filters.shopCategoriesWhitelist || {};
    const keys = Object.keys(whitelist);

    if (this.originalProductList.length === 0) {
        this.originalProductList = this.productList.slice(0);
    }

    if (keys.length === 0) {
        this.productList = this.originalProductList.slice(0);
        return;
    }

    const whitelistedProds = [];
    for (let i = 0; i < keys.length; i++) {
        whitelistedProds.push.apply(whitelistedProds, whitelist[keys[i]]);
    }
    this.productList = [...new Set(whitelistedProds)];
};

DazProductList.prototype.refreshVisibleFilters = function(excludeType) {
    for (let filterType in this.filterData) {
        if (filterType === excludeType || filterType === 'shopCategories') {
            continue;
        }
        if (this.filterData[filterType].elemNew && this.filterData[filterType].elemNew.length) {
            this.filterData[filterType].sorted = false;
            this.sortFilter(filterType);
        }
    }
};

/*** Catalog Filter Functions ***/
DazProductList.prototype.sortFilter = function(filterType) {
    let sortedFilter = [];
    let seenFilters = {};
    let listedFilters = {};
    for (let filterOpt in daz.filter.filters[filterType]) {
        var filterArgs = {owned: this.filterSettings.owned};
        if (this.isPriceFilterActive()) {
            filterArgs.price = this.filterSettings.price;
        }
        filterArgs[filterType] = [filterOpt];
        var testList = daz.filter.filterProducts(this.productList, filterArgs);
        seenFilters[filterOpt] = true;
        if (testList.length > 0) {
            sortedFilter.push([filterOpt,testList.length]);
            listedFilters[filterOpt] = true;
        }
    }

    const selectedValues = filterType === 'file_formats' && daz.filter && daz.filter.normalizeFileFormatFilterValues
        ? daz.filter.normalizeFileFormatFilterValues(this.getSelectedFilterValues(filterType))
        : this.getSelectedFilterValues(filterType);
    for (let i = 0; i < selectedValues.length; i++) {
        if (!listedFilters[selectedValues[i]] && seenFilters[selectedValues[i]]) {
            sortedFilter.push([selectedValues[i], 0]);
            listedFilters[selectedValues[i]] = true;
        }
    }

    if (filterType === 'file_formats') {
        sortedFilter.sort(function(a, b) {
            return a[0].localeCompare(b[0], undefined, { sensitivity: 'base' });
        });
    } else if (!daz.filter.filterSorts || !daz.filter.filterSorts[filterType]) {
        sortedFilter.sort(function(a,b){ if (a[1]< b[1]) {return 1;} else if (a[1]>b[1]){ return -1; } return 0; });
    } else {
        // Create a sort "lookup"
        let filterSort = {};
        for (let i = 0; i < daz.filter.filterSorts[filterType].length; i++) {
            filterSort[daz.filter.filterSorts[filterType][i]] = i;
        }
        sortedFilter.sort(function(a,b) {
            let aSort = -1;
            let bSort = -1;
            if (filterSort[a[0]] !== undefined) {
                aSort = filterSort[a[0]];
            }
            if (filterSort[b[0]] !== undefined) {
                bSort = filterSort[b[0]];
            }
            if (aSort < bSort) {
                return -1;
            } else if ( bSort < aSort) {
                return 1;
            } else {
                if (a[0] < b[0]) {
                    return -1;
                } else {
                    return 1;
                }
            }
        });
    }

    let view = this.layout

    if (view === 'old') {
        let elem = this.filterData[filterType].elem.find('ul');
        elem.empty();

        if (sortedFilter.length > 15) {
            var label = $('div.'+filterType+'_container a label')[0].textContent;
            var newElem = $('<input maxlength=255 class=filter_search size=32 data-filtertype="'+filterType+'" type=text placeholder="Enter '+label+' name...">');

            newElem.on('keyup', $.proxy(this.handleFilterSearch,this));

            elem.append(newElem);
        }

        for (let i in sortedFilter) {
            var idx = sortedFilter[i][0];
            var len = sortedFilter[i][1];

            if (len == 0) {
                continue;
            }
            
            var extraHtml = '';
            if (i > 15) {
                extraHtml = 'style="display: none;"';
            } else {
                extraHtml = 'class="filter_visible"';
            }

            var largeElem = $('<li id="'+this.filterGetId('large',filterType,idx)+'" data-filterval="'+idx+'"   '+extraHtml+'><input id="'+this.filterGetId('large',filterType,idx)+'_check" type=checkbox data-filtertype="'+filterType+'" value="'+idx+'">'+idx+' (<span id="'+this.filterGetId('large',filterType,idx)+'_count" class="filter_count">'+len+'</span>)</li>');

            largeElem.on('click',$.proxy(this.handleFilterClick,this));
            elem.append(largeElem);
        }

        if (this.filterSettings[filterType]) {
            for (let i = 0; i < this.filterSettings[filterType].length; i++) {
                var elemId = this.filterGetId('large', filterType, this.filterSettings[filterType][i]);
                $('#'+elemId+'_check').prop('checked',true);
                if ($('#'+elemId).css('display') == 'none') {
                    // If it is selected, don't let it be auto-hidden
                    $('#'+elemId).css('display','').addClass('filter_visible');
                }

            }
        }
    } else if (view === 'new') {
        if (filterType === 'shopCategories') {
            let listUl = this.filterData[filterType].elemNew.find('ul.outer-ul');
            let templateLiOuter = listUl.find('li.li-template-outer').clone().removeClass('li-template-outer').removeAttr('style');
            let templateLiInner = listUl.find('li.li-template-inner').clone().removeClass('li-template-inner').removeAttr('style');
            listUl.children('li').not('.li-template-outer').not('.li-template-inner').remove();
        
            const { shopCategories } = daz.filter.filters;
            
            for (let catName in shopCategories) {
                // main level of categories setup
                let templateLiOuterClone = templateLiOuter.clone();
                const outerId = this.filterGetId('large', filterType, catName);
                const isSelected = daz.filter.filters.shopCategoriesWhitelist && daz.filter.filters.shopCategoriesWhitelist[shopCategories[catName].id];

                templateLiOuterClone.attr({
                    'id': shopCategories[catName].id,
                    'data-filterval': catName
                });
                templateLiOuterClone.toggleClass('filter-option-selected', !!isSelected);
                templateLiOuterClone.find('span.idx').text(catName)
                templateLiOuterClone.find('input').attr({
                    'id': outerId + '_check',
                    'value': catName
                }).prop('checked', !!isSelected).on('change', $.proxy(this.handleShopCategoryChange, this));
                
                // subcategories level setup
                if (shopCategories[catName].hasOwnProperty('childrenInfo')) {
                    templateLiOuterClone.addClass('has-children');
                    templateLiOuterClone.find('.category-children-toggle').on('click', $.proxy(this.handleShopCategoryExpand, this));
                    for (let i = 0; i < shopCategories[catName].childrenInfo.length; i++) {
                        let templateLiInnerClone = templateLiInner.clone();
                        const innerId = this.filterGetId('large', filterType, shopCategories[catName].childrenInfo[i].name);
                        const childId = shopCategories[catName].childrenInfo[i].id;
                        const childSelected = daz.filter.filters.shopCategoriesWhitelist && daz.filter.filters.shopCategoriesWhitelist[childId];
    
                        templateLiInnerClone.attr({
                            'id': childId,
                            'data-filterval': shopCategories[catName].childrenInfo[i].name
                        });
                        templateLiInnerClone.toggleClass('filter-option-selected', !!childSelected);
        
                        templateLiInnerClone.find('span.idx').text(shopCategories[catName].childrenInfo[i].name)
                        templateLiInnerClone.find('span.filter_count').attr('id', innerId + '_count').text(this.formatFilterCount(shopCategories[catName].childrenInfo[i].products))
                        templateLiInnerClone.find('input').attr({
                            'id': innerId + '_check',
                            'value': shopCategories[catName].childrenInfo[i].name
                        }).prop('checked', !!childSelected).on('change', $.proxy(this.handleShopCategoryChange, this));
                        templateLiInnerClone.appendTo(templateLiOuterClone.find('ul.category-children'));
                    }
                } else {
                    templateLiOuterClone.find('.category-children-toggle').remove();
                }

                templateLiOuterClone.appendTo(listUl)
            }

            this.updateSelectedCategoryCount();
            this.refreshFilterListVisibility(filterType);
        } else {
            let searchInput = this.filterData[filterType].elemNew.find('input.filter_search');
            searchInput.off('keyup.dazFilterSearch input.dazFilterSearch').on('keyup.dazFilterSearch input.dazFilterSearch', $.proxy(this.handleNewFilterSearch,this));

            if (sortedFilter.length < 6 || filterType === 'file_formats') {
                searchInput.hide();
            }
            else {
                searchInput.show();
            }

            let $filterContainer = this.filterData[filterType].elemNew;
            let selectedUl = $filterContainer.find('ul.selected-list');
            selectedUl.attr('data-list-type', `${filterType}`);

            let listUl = $filterContainer.find('ul.products-list').first();
            if (filterType === 'file_formats') {
                $filterContainer.find('.file-format-loading').remove();
                listUl = $filterContainer.find('ul.products-list[data-format-group]');
                listUl.attr('data-list-type', `${filterType}-listed`);
                listUl.children('li').not('.li-template').remove();
            } else {
                listUl.attr('data-list-type', `${filterType}-listed`);
                listUl.children('li').not('.li-template').remove();
            }

            let templateLi = $filterContainer.find('li.li-template').first().clone().removeClass('li-template').removeAttr('style');

            if (filterType === 'file_formats' && daz.filter.seedFileFormatFilterSettings) {
                daz.filter.seedFileFormatFilterSettings(this.filterSettings);
            }

            for (let i in sortedFilter) {
                let tempClone = templateLi.clone();
    
                let idx = sortedFilter[i][0];
                let id = this.filterGetId('large',filterType,idx);
                let len = sortedFilter[i][1];
                let isSelected = this.isFilterValueSelected(filterType, idx);
                let targetList = filterType === 'file_formats'
                    ? $filterContainer.find('ul.products-list[data-format-group="' + daz.filter.getFileFormatGroup(idx) + '"]')
                    : listUl;
    
                tempClone.attr({
                    'id': id,
                    'data-filterval': idx,
                    'data-filter-count': len
                });
                tempClone.toggleClass('filter-option-selected', isSelected);
    
                tempClone.find('input').attr({
                    'id': id+'_check',
                    'data-filtertype': filterType,
                    'value': idx
                }).prop('checked', isSelected).on('change', $.proxy(this.handleFilterInputChange, this));
    
                tempClone.find('span.idx').text(idx);
                tempClone.find('span.filter_count').attr('id', id+'_count').text(this.formatFilterCount(len));

                tempClone.appendTo(targetList);
            }

            if (filterType === 'file_formats' && daz.filter.tryApplyFileFormatPreferences) {
                daz.filter.tryApplyFileFormatPreferences();
            }

            if (filterType === 'file_formats' && daz.filter.organizeFileFormatGroups) {
                daz.filter.organizeFileFormatGroups();
            }

            this.refreshFilterListVisibility(filterType);
        }
    }

    this.filterData[filterType].sorted = true;

    this.filterUpdateCounts();
};

DazProductList.prototype.filterExpand = function (filterType) {
    this.filterData[filterType].visible = true
    this.updateSectionToggleAria(filterType, true);

    if (!this.filterData[filterType].sorted) {
        let self = this
        window.setTimeout(function () {
            self.sortFilter(filterType)
        }, 150)
    }
}

DazProductList.prototype.filterCollapse = function(filterType) {
    this.filterData[filterType].visible = false;
    this.updateSectionToggleAria(filterType, false);
};

DazProductList.prototype.filterDropdownShow = function (filterType) {
    this.filterData[filterType].visible = true

    if (!this.filterData[filterType].sorted) {
        let elem = this.filterData[filterType].elem.find('ul')
        elem.html('<b>Loading...</b>')
        let self = this
        window.setTimeout(function () {
            self.sortFilter(filterType)
        }, 150)
    }
}

DazProductList.prototype.filterDropdownHide = function(filterType) {
    this.filterData[filterType].visible = false;
};

DazProductList.prototype.setupFilters = function() {
    if (this.hasSetupFilters) {
        return;
    }
    this.hasSetupFilters = true;

    daz.filter.onFileFormatPreferencesApplied = $.proxy(this.handleFileFormatPreferencesApplied, this);

    if (daz.filter.flushFileFormatFilterTrigger) {
        daz.filter.flushFileFormatFilterTrigger();
    }

    $('#filter_container').on('daztoggle-hide', $.proxy(this.filterModalClose,this));
    $('a.modal-filter-apply').on('click', $.proxy(this.filterModalApply, this));
    $('a.modal-filter-clear').on('click', $.proxy(this.filterModalClear, this));

    $('div.sort_container').on('click',$.proxy(this.handleOrderClick, this));
    $('select[name="sort-by"]').on('change',$.proxy(this.handleSortBy, this));
    $('#category-filter-panel input.owned_check, #large_owned input.owned_check').on('change', $.proxy(this.ownedHandleClick, this));
    $('#category-filter-panel input.platClub_check, #large_platClub input.platClub_check').on('change', $.proxy(this.platClubHandleClick, this));
    $('#category-filter-panel input.bundle_check, #large_bundle input.bundle_check').on('change', $.proxy(this.bundleHandleClick, this));
    $('#category-filter-panel input.wishlist_check, #large_wishlist input.wishlist_check').on('change', $.proxy(this.wishlistHandleClick, this));
    $('#filter_clear_container').find('.filter-clear').on('click', $.proxy(this.filterClear, this));
    $('.filter-panel-clear').on('click', $.proxy(this.filterClear, this));
    $('.filter-show-more').on('click', $.proxy(this.handleShowMoreClick, this));
    $('.filter-panel .daz-toggler').on('click', function() {
        const $button = $(this);
        const target = $button.attr('data-toggleelem');
        window.setTimeout(function() {
            const visible = $(target).is(':visible');
            $button.attr('aria-expanded', visible ? 'true' : 'false');
            $button.toggleClass('daztoggle_active', visible);
        }, 120);
    });
    this.initPriceFilter();
    let self = this;

    // Note: showCallback and hideCallback are functions for the older style dropdown filters
    let showCallback = function(type) {
        return function() {
            self.layout = 'old'
            self.filterDropdownShow.call(self,type);
        }
    };
    let hideCallback = function(type) {
        return function() {
            self.filterDropdownHide.call(self,type);
        }
    };

    // Note: expandCallback and collapseCallback are functions for the newer style scrollable filters
    let expandCallback = function(type) {
        return function() {
            self.layout = 'new'
            self.filterExpand.call(self,type);
        }
    };
    let collapseCallback = function(type) {
        return function() {
            self.filterCollapse.call(self,type);
        }
    };

    // BEGIN: initialize shopCategories filter to filters (also whitelisted in filter.js)
    const { categoryId } = this;
    const allCategories = { ...daz.filter.rawCategories };
    
    daz.filter.filters.shopCategories = {};
    daz.filter.filters.shopCategoriesWhitelist = {};

    // temp array used to build up the shop's categories
    const shopCategories = [];
    
    // does this category page have categories to display for filtering?
    for (let key in allCategories) {
        if (allCategories[key].parent === categoryId && allCategories[key].visible === true) {
            const newCatObj = {id: +key, name: allCategories[key].name}

            if (allCategories[key].hasOwnProperty('children')) {
                newCatObj.children = [ ...allCategories[key].children ]
                newCatObj.childrenInfo = [];
            }

            shopCategories.push(newCatObj);
        }
    }

    if (shopCategories.length > 0) {
        for (let i = 0; i < shopCategories.length; i++) {
            // does the main category have subcategories?
            if (shopCategories[i].hasOwnProperty('children')) {
                for (let j = 0; j < shopCategories[i].children.length; j++) {
                    if (allCategories[shopCategories[i].children[j]] !== undefined) {
                        const childInfo = {
                            id: shopCategories[i].children[j],
                            name: allCategories[shopCategories[i].children[j]].name
                        }
    
                        if (allCategories[shopCategories[i].children[j]].hasOwnProperty('products')) {
                            let products = this.recursiveProducts(shopCategories[i].children[j])
                            childInfo.products = products? products.length : 0
                        }
        
                        shopCategories[i].childrenInfo.push(childInfo)
                    }
                }
                // sort the child categories by name alphabetically a-z
                shopCategories[i].childrenInfo.sort((a, b) => a.name.localeCompare(b.name))
            }
        }

        // sort main categories alphabetically a-z, then add to daz filters
        shopCategories.sort((a, b) => a.name.localeCompare(b.name))
        for (let i = 0; i < shopCategories.length; i++) {
            daz.filter.filters.shopCategories[shopCategories[i].name] = { ...shopCategories[i] };

            // remove name property from main category (redundant since it's the key)
            delete daz.filter.filters.shopCategories[shopCategories[i].name].name;
        }
    } else {
        // if no categories to display, remove the Category filter page element
        if (document.querySelector('#shopCategoriesContainer') != null) {
            document.querySelector('#shopCategoriesContainer').remove();
        }
    }
    // END add shopCategories filter to filters    

    for (var filterType in daz.filter.filters) {
        if (filterType == 'owned'
            || filterType == 'category'
            || filterType == 'platClub'
            || filterType == 'inCart'
            || filterType == 'new'
            || filterType == 'bundle'
            || filterType == 'wishList'
            || filterType == 'shopCategoriesWhitelist') {
            continue;
        }

        var elem = $('#'+filterType+'_drop');
        var elemNew = $('#'+filterType+'List');

        if (!elem[0] && !elemNew[0]) {
            continue;
        }

        elem.on('daztoggle-show', showCallback(filterType));
        elem.on('daztoggle-hide', hideCallback(filterType));

        elemNew.on('daztoggle-show', expandCallback(filterType));
        elemNew.on('daztoggle-hide', collapseCallback(filterType));

        this.filterData[filterType] = {elem: elem, elemNew: elemNew, sorted: false, visible: false};

        if (elemNew[0] && (elemNew.is(':visible') || elemNew.closest('.filter-panel').length)) {
            this.layout = 'new';
            this.filterExpand(filterType);
        }
    }
};

DazProductList.prototype.handleFilterSearch = function(event) {
    var filterType = $(event.target).attr('data-filtertype');
    var searchTerm = event.target.value.toLowerCase();
    var i = 0;
    this.filterData[filterType].elem.find('li').each(function(idx, elem) {
        var $elem = $(elem);
        if (i > 15 && !$elem.find('input').prop('checked')) {
            $elem.css('display','none');
            $elem.removeClass('filter_visible');
            return;
        }

        if (searchTerm != '' && elem.textContent.toLowerCase().indexOf(searchTerm) == -1) {
            // Didn't find it
            $elem.css('display','none');
            $elem.removeClass('filter_visible');
        } else {
            i++;
            $elem.css('display','block');
            $elem.addClass('filter_visible');
        }
    });

    this.filterUpdateCounts();
};

DazProductList.prototype.handleNewFilterSearch = function(event) {
    let filterType = $(event.target).attr('data-filtertype');
    this.refreshFilterListVisibility(filterType);
};

DazProductList.prototype.handleShopCategoryExpand = function(event) {
    event.preventDefault();
    event.stopPropagation();

    const $button = $(event.currentTarget);
    const $category = $button.closest('li.js-filter-option-container');
    const expanded = !$category.hasClass('category-expanded');

    $category.toggleClass('category-expanded', expanded);
    $button.attr({
        'aria-expanded': expanded ? 'true' : 'false',
        'aria-label': expanded ? 'Hide subcategories' : 'Show subcategories'
    });
};

DazProductList.prototype.handleShopCategoryChange = function(event) {
    event.stopPropagation();

    const $input = $(event.currentTarget);
    const $category = $input.closest('li.js-filter-option-container');
    const catId = $category.attr('id');

    if (!daz.filter.filters.shopCategoriesWhitelist) {
        daz.filter.filters.shopCategoriesWhitelist = {};
    }

    if ($input.prop('checked')) {
        daz.filter.filters.shopCategoriesWhitelist[catId] = this.recursiveProducts(catId);
    } else {
        delete daz.filter.filters.shopCategoriesWhitelist[catId];
    }

    $category.toggleClass('filter-option-selected', $input.prop('checked'));
    this.updateCategoryProductList();
    this.updateSelectedCategoryCount();
    this.refreshVisibleFilters('shopCategories');
    this.applyFilters(true);
    this.handleClick(true);
};

DazProductList.prototype.handleFilterInputChange = function(event) {
    event.stopPropagation();

    const elem = $(event.currentTarget);
    const value = elem.val();
    const filterType = elem.attr('data-filtertype');
    const checked = elem.prop('checked');

    if (!this.filterSettings[filterType]) {
        this.filterSettings[filterType] = [];
    }

    const filterPos = this.filterSettings[filterType].indexOf(value);

    if (checked && filterPos === -1) {
        this.filterSettings[filterType].push(value);
    } else if (!checked && filterPos !== -1) {
        this.filterSettings[filterType].splice(filterPos, 1);
    }

    elem.closest('li.js-filter-option-container').toggleClass('filter-option-selected', checked);
    this.refreshFilterListVisibility(filterType);

    window.setTimeout($.proxy(function() {
        this.applyFilters(true);
        this.handleClick(true);
    }, this), 5);
};

DazProductList.prototype.handleFileFormatPreferencesApplied = function(values) {
    if (!values || !values.length) {
        return;
    }

    if (daz.filter.normalizeFileFormatFilterValues) {
        values = daz.filter.normalizeFileFormatFilterValues(values);
    }

    this.filterSettings.file_formats = values.slice();

    window.setTimeout($.proxy(function() {
        this.applyFilters(true);
        this.handleClick(true);
        if (this.infiniteScroll && typeof this.fillVisibleSlabs === 'function') {
            this.topLeftIndex = null;
            this.fillVisibleSlabs(true);
        }
    }, this), 5);
};

DazProductList.prototype.handleFilterClick = function(event) {
    event.stopPropagation();

    var elem = $(event.target).closest('li').find('input');
    if (!elem[0]) {
        return;
    }

    var value = elem.val();
    var filterType = elem.attr('data-filtertype');
    var shouldCheck = true;

    if (!this.filterSettings[filterType]) {
        this.filterSettings[filterType] = [];
    }

    var filterPos = this.filterSettings[filterType].indexOf(value);

    if (filterPos != -1) {
        shouldCheck = false;

        this.filterSettings[filterType].splice(filterPos,1);
    } else {
        this.filterSettings[filterType].push(value);
    }

    $('#'+this.filterGetId('large',filterType,value)+'_check').prop('checked',shouldCheck);

    window.setTimeout($.proxy(function() { this.applyFilters(true); },this),5);
};

DazProductList.prototype.resetQuickFilters = function() {
    this.filterSettings.owned = true;
    delete this.filterSettings.bundle;
    delete this.filterSettings.platClub;
    delete this.filterSettings.inWishlist;

    $('.owned_check').prop('checked', true);
    $('.platClub_check').prop('checked', false);
    $('.bundle_check').prop('checked', false);
    $('.wishlist_check').prop('checked', false);

    daz.api.sessionStoragePut('showOwned', true);
    daz.api.sessionStoragePut('platClubOnly', false);
    daz.api.sessionStoragePut('bundleOnly', false);
    daz.api.sessionStoragePut('wishListOnly', false);
};

DazProductList.prototype.filterClear = function(event) {
    $('.platClub_check').prop('checked',false);
    $('#filter_container').find('input').prop('checked',false);
    $('.filter-panel').find('input[type="checkbox"]').prop('checked', false);
    $('.filter-panel').find('input.filter_search').val('');
    $('.filter-panel').find('.filter-option-selected').removeClass('filter-option-selected');
    $('.filter-panel').find('.selected-list').empty();
    $('.filter-panel').find('.collapse-container').attr('data-show-all', 'false');
    this.resetQuickFilters();
    this.filterSettings = {owned: true};
    this.selectedFilters = [];

    if (daz.filter.filters.shopCategoriesWhitelist) {
        daz.filter.filters.shopCategoriesWhitelist = {};
    }
    if (this.originalProductList.length > 0) {
        this.productList = this.originalProductList.slice(0);
    }
    this.updateSelectedCategoryCount();
    this.resetPriceFilter();

    daz.api.sessionStoragePut('platClubOnly', false);

    if (event) {
        event.preventDefault();
    }

    this.refreshVisibleFilters();
    this.applyFilters(true);
    this.handleClick(true);
};

DazProductList.prototype.filterModalApply = function() {
    $('#filter_container').trigger('daztoggle-hide');
}

DazProductList.prototype.filterModalClose = function(event) {
};

DazProductList.prototype.filterModalClear = function(event) {
    this.filterClear();

    // Hide the modal
    $('#filter_container').trigger('daztoggle-hide');
}

DazProductList.prototype.loadFilterFromHash = function() {
    for (var filterType in daz.filter.filters) {
        if (this.urlHash.fparam('filter_'+filterType)) {
            if (filterType == "platClub") {
                // If we are filtering Daz Plus, don't let them change it.
                $('#large_platClub').hide();
            }
            var filter = this.urlHash.fparam('filter_'+filterType).split('^');
            this.filterSettings[filterType] = [];
            for (var i = 0; i < filter.length; i++) {
                this.filterSettings[filterType].push(filter[i]);
            }
            
            // Update UI checkboxes for specific filter types
            if (filterType == "platClub" && filter.includes("yes")) {
                $('.platClub_check').prop('checked', true);
            }
            if (filterType == "inWishlist" && filter.includes("yes")) {
                $('.wishlist_check').prop('checked', true);
            }
        }
    }

    if (this.urlHash.fparam('filter_price')) {
        const price = this.urlHash.fparam('filter_price').split('^');
        if (price.length >= 2) {
            this.filterSettings.price = [parseInt(price[0], 10), parseInt(price[1], 10)];
            this.syncPriceFilterUI();
        }
    }

    var order = this.urlHash.fparam('order')
    if (order) {
        this.sortOrderSettings = order.split('^');
        let sortDir = this.sortOrderSettings[1] == '-1' ? '-1' : '1';
        let elem = $('#sort_drop').find('li[data-sortdata="' + this.sortOrderSettings[0] +'"][data-sortdir="' + sortDir + '"]');
        // Thanks foundation for not having a better way to close dropdowns.
        let parentElem = $('div.sort_container');
        parentElem.click();
        parentElem.find('.location').html(elem.text());
    }
};

DazProductList.prototype.applyFilters = function(doScroll) {
    if (!this.catalogReady) {
        this.applyFiltersImpl(doScroll);
        return;
    }

    var self = this;
    var token = this.showFilterLoading();

    window.requestAnimationFrame(function() {
        self.applyFiltersImpl(doScroll);
        self.waitForSlabsToFinish(function() {
            self.hideFilterLoading(token);
        });
    });
};

DazProductList.prototype.applyFiltersImpl = function(doScroll) {
    this.reset();
    var filterCount = 0;
    var hasFilter = false;
    for (var filterName in this.filterSettings) {
        if (filterName == 'owned') {
            continue;
        }
        if (this.filterSettings[filterName].length < 1) {
            continue;
        }
        hasFilter = true;
        for (var i in this.filterSettings[filterName]) {
            filterCount++;
        }
    }
    this.ordered = [...new Set(daz.filter.filterProducts(this.productList, this.filterSettings))];

    var direction = 'ASC';
    if (this.sortOrderSettings[1] == 1) {
        // Reverse sort
        direction = 'DESC';
    }

    this.ordered = daz.filter.sortProducts(this.ordered, this.sortOrderSettings[0], direction);

    this.filterUpdateCounts();
    var html = this.formatFilterCount(this.ordered.length)+' of '+this.formatFilterCount(this.productCount !== -1 ? this.productCount : this.productList.length)+' items';
    $('#catalog_amount').html(html);
    var filterTotal = this.getActiveFilterCount();
    for (var filterType in daz.filter.filters) {
        if (filterType == 'owned') {
            continue;
        }
        var filterCount = 0;
        if (typeof this.filterSettings[filterType] == 'object') {
            filterCount = this.filterSettings[filterType].length;
        }
        if (filterCount > 0) {
            $('#large_'+filterType+'_count').html(filterCount).css('visibility','visible');
        } else {
            $('#large_'+filterType+'_count').html(0).css('visibility','hidden');
        }
    }
    if (filterTotal > 0) {
        $('#small_filter_count').html(filterTotal).css('visibility','visible');
        $('#filter_clear_container').css('display','');
        $('.filter-panel-clear').prop('disabled', false);
    } else {
        $('#small_filter_count').html(0).css('visibility','hidden');
        $('#filter_clear_container').css('display','none');
        $('.filter-panel-clear').prop('disabled', true);
    }

    if (doScroll) {
        if (this.infiniteScroll) {
            this.handleScroll();
        } else {
            this.buildPagination();
            this.switchPage(0);
        }
    }

    this.applyHiddenFiltersCss()
};

DazProductList.prototype.filterGetId = function(filterSize, filterType, filter) {
    var filterId = 'filter_'+filterSize+'_'+filterType+'_'+filter;
    return filterId.replace(/[^A-z0-9_]+/g, '_');
};

DazProductList.prototype.getFilterCountContainer = function(filterType) {
    if (!this.filterData[filterType]) {
        return $();
    }

    return this.filterData[filterType].elemNew && this.filterData[filterType].elemNew.length
        ? this.filterData[filterType].elemNew
        : this.filterData[filterType].elem;
};

DazProductList.prototype.getFilterCountRows = function(filterType, includeHidden) {
    var $container = this.getFilterCountContainer(filterType);
    if (!$container || !$container.length) {
        return $();
    }

    if (this.filterData[filterType].elemNew && this.filterData[filterType].elemNew.length) {
        var filterElems = $container.find('li.js-filter-option-container')
            .not('.li-template')
            .not('.li-template-outer')
            .not('.li-template-inner');

        if (includeHidden) {
            return filterElems;
        }

        return filterElems;
    }

    return $container.find('li.filter_visible');
};

DazProductList.prototype.updateFilterCountsForType = function(filterType, includeHidden, countGeneration) {
    var $container = this.getFilterCountContainer(filterType);
    if (!$container || !$container.length) {
        return;
    }

    if (!countGeneration) {
        this.filterCountGeneration++;
        countGeneration = this.filterCountGeneration;
    }

    var filterElems = this.getFilterCountRows(filterType, includeHidden);
    if (!filterElems.length) {
        return;
    }

    $container.attr('data-filter-count-generation', countGeneration);

    var visibleCounted = 0;
    var visibleLimit = filterType === 'file_formats' ? 9999 : this.filterVisibleLimit;
    var isNewFilterPanel = this.filterData[filterType].elemNew && this.filterData[filterType].elemNew.length;

    for (var i = 0; i < filterElems.length; i++) {
        var filterOpt = $(filterElems[i]).attr('data-filterval');
        if (filterOpt === undefined) {
            continue;
        }

        var checked = $(filterElems[i]).find('input[type="checkbox"]').filter(':checked').length > 0;
        var shouldCount = includeHidden || !isNewFilterPanel || checked || visibleCounted < visibleLimit;
        if (!shouldCount) {
            continue;
        }

        var filterArgs = JSON.parse(JSON.stringify(this.filterSettings));
        filterArgs[filterType] = [filterOpt];
        var foundList = daz.filter.filterProducts(this.productList, filterArgs);
        var elem = document.getElementById(this.filterGetId('large',filterType,filterOpt)+'_count');
        $(filterElems[i]).attr({
            'data-filter-count': foundList.length,
            'data-filter-count-generation': countGeneration
        }).toggleClass('filter-option-empty', !foundList.length);
        if (elem) {
            elem.innerHTML = this.formatFilterCount(foundList.length);
        }

        if (foundList.length || checked) {
            visibleCounted++;
        }
    }

    this.refreshFilterListVisibility(filterType);
};

DazProductList.prototype.filterUpdateCounts = function() {
    this.filterCountGeneration++;

    this.verifySelectedFileFormatsInDom();

    for (var filterType in daz.filter.filters) {
        if (filterType == 'owned' ||
            filterType == 'category' ||
            filterType == 'platClub' ||
            filterType == 'bundle' ||
            filterType == 'platinum_club' ||
            filterType == 'wishlist' ||
            filterType == 'shopCategories' ||
            filterType == 'shopCategoriesWhitelist' ||
            !this.filterData[filterType]) {
            continue;
        }

        this.updateFilterCountsForType(filterType, false, this.filterCountGeneration);
    }

    // Trigger a reflow
    $('#filter_container .dropdown_content').css('margin-left','0.05px');
    window.setTimeout(function() { $('#filter_container .dropdown_content').css('margin-left',''); }, 1);

};

DazProductList.prototype.ownedHandleClick = function(event) {
    var check;
    if (event && event.currentTarget) {
        check = $(event.currentTarget).is(':checked');
        this.filterSettings.owned = check;
    } else {
        this.filterSettings.owned = !this.filterSettings.owned;
        check = !!this.filterSettings.owned;
    }
    daz.api.sessionStoragePut('showOwned', check);

    $('.owned_check').prop('checked', check);

    if (event) {
        event.stopPropagation();
    }
    this.applyFilters(true);
};

DazProductList.prototype.platClubHandleClick = function(event) {
    var check = false;

    if (!this.filterSettings.platClub) {
        this.filterSettings.platClub = ['yes'];
        check = true;
    } else {
        delete this.filterSettings.platClub;
        check = false;
    }
    daz.api.sessionStoragePut('platClubOnly', check);

    $('.platClub_check').prop('checked', check);

    if (event) {
        event.stopPropagation();
    }

    this.applyFilters(true);
};

DazProductList.prototype.bundleHandleClick = function(event) {
    var check = false;

    if (!this.filterSettings.bundle) {
        this.filterSettings.bundle = ['yes'];
        check = true;
    } else {
        delete this.filterSettings.bundle;
        check = false;
    }
    daz.api.sessionStoragePut('bundleOnly', check);

    $('.bundle_check').prop('checked', check);

    if (event) {
        event.stopPropagation();
    }

    this.applyFilters(true);
};

DazProductList.prototype.wishlistHandleClick = function(event) {
    var isChecked;
    if (event && event.currentTarget) {
        isChecked = $(event.currentTarget).is(':checked');
    } else {
        isChecked = !this.filterSettings.inWishlist;
    }

    if (isChecked) {
        this.filterSettings.inWishlist = ['yes'];
    } else {
        delete this.filterSettings.inWishlist;
    }

    daz.api.sessionStoragePut('wishListOnly', isChecked);

    $('.wishlist_check').prop('checked', isChecked);

    if (event) {
        event.stopPropagation();
    }
    this.applyFilters(true);
};

DazProductList.prototype.applyHiddenFiltersCss = function() {
  const $items = $('#slabs-container').children('.item');
  const $wishlistItems = $('.wishlist-grid').children('.item');
  const clearItemInlineLayout = () => {
    $items.css({ width: '', marginLeft: '', marginRight: '', margin: '' });
    $wishlistItems.css({ width: '', marginLeft: '', marginRight: '', margin: '' });
  };

  if ($('#collapsible-product-filters-container').hasClass('product-filters-container')) {
    clearItemInlineLayout();
    return;
  }

  // Sidebar collapsed — layout is CSS-driven; strip legacy inline tile widths.
  clearItemInlineLayout();

  const defaultStyleRaw = $('.filter-collapse-button').attr('data-defaultStyle');
  if (!defaultStyleRaw) {
    return;
  }

  let defaultStyle;
  try {
    defaultStyle = JSON.parse(defaultStyleRaw);
  } catch (e) {
    return;
  }

  if (defaultStyle.topFilterContainer) {
    $('#top-filters-container').css(defaultStyle.topFilterContainer);
  }
}

/*** Pagination functions ***/
DazProductList.prototype.switchPage = function(pageNum) {
    this.reset();
    this.currPage = pageNum;
    this.orderedStart = pageNum * this.pageSize;

    var numToLoad = this.pageSize;
    if (pageNum == 0) {
        numToLoad -= this.reuseExistingSlabs(this.pageSize);
    } else {
        this.listElem.html('');
    }

    this.addPlaceholders(numToLoad);
    this.buildPagination();
    this.handleScroll();
    this.applyHiddenFiltersCss()
};

DazProductList.prototype.handlePaginationMaybeScroll = function(event) {
    event.preventDefault();

    if ($(event.target).closest('.toolbar.bottom')[0]) {
        $('html, body').animate({scrollTop: $('.filters').offset().top-40}, 200);
    } else if ($(event.target).closest('.pagination_container')[0]) {
        // do not use scroll behavior smooth -- it has the effect of requesting all new slabs data while scrolling to top
        $(document).scrollTop($('#top-header').offset().top - 120)
    }
};

DazProductList.prototype.handlePaginationPrev = function(event) {
    this.handlePaginationMaybeScroll(event);

    if (this.currPage > 0) {
        this.switchPage(this.currPage - 1);
        this.handleClick(true);
    }
};

DazProductList.prototype.handlePaginationNext = function(event) {
    this.handlePaginationMaybeScroll(event);

    var maxPages = Math.ceil(this.ordered.length / this.pageSize) - 1;
    if (this.currPage < maxPages) {
        this.switchPage(this.currPage + 1);
        this.handleClick(true);
    }
};

DazProductList.prototype.getPageCount = function() {
    if (this.pageCount > 0) {
        return this.pageCount;
    }

    if (!this.ordered || !this.pageSize || this.pageSize < 1) {
        return this.lastPagenum || 1;
    }

    return Math.max(1, Math.ceil(this.ordered.length / this.pageSize));
};

DazProductList.prototype.syncGoToPageInput = function() {
    if (!this.$goToPageInput || !this.$goToPageInput.length) {
        return;
    }

    const pageNum = String(this.currPage + 1);
    const pageCount = this.getPageCount();

    this.$goToPageInput.attr({
        'max': pageCount,
        'min': 1,
        'data-active-page': pageNum,
        'placeholder': pageNum
    });
};

DazProductList.prototype.handlePaginationBlankClick = function(event) {
    event.stopPropagation();
    if (!this.$goToPageInput.length) return;

    const currPagenum = String(this.currPage + 1);
    const pageCount = this.getPageCount();

    this.$goToPageInput.attr({
        'max': pageCount,
        'data-active-page': currPagenum,
        'placeholder': currPagenum
    }).val(currPagenum).focus().select();

    if (!this.$goToPageContainer.length) {
        return;
    }

    this.lastPagenum = pageCount;
    this.$goToPageContainer.find('.last_pagenum').text(pageCount);

    this.$goToPageContainer.removeClass('bs5-d-none');
    this.$controlsContainer.fadeOut(this.paginationTransitionSpd, () => {
        this.$goToPageContainer.css('display', 'inline-flex').hide().fadeIn(this.paginationTransitionSpd, () => {
            this.$goToPageInput.select();
        });
    })
};

DazProductList.prototype.handlePaginationGoToPageKeydown = function(event) {
    if (event.key !== 'Enter') {
        return;
    }

    event.preventDefault();
    this.submitGoToPageInput();
};

DazProductList.prototype.handlePaginationGoToPageChange = function() {
    clearTimeout(this.goToPageTimeout);
    this.goToPageTimeout = setTimeout($.proxy(this.submitGoToPageInput, this), 300);
};

DazProductList.prototype.submitGoToPageInput = function() {
    clearTimeout(this.goToPageTimeout);
    this.goToPageTimeout = null;

    const inputVal = String(this.$goToPageInput.val()).trim();

    if (!inputVal || !this.validatePagenumInput(inputVal)) {
        return;
    }

    if (this.$goToPageInput.attr('data-active-page') === inputVal) {
        return;
    }

    this.applyGoToPage(inputVal);
};

DazProductList.prototype.applyGoToPage = function(inputVal) {
    $(document).scrollTop($('#top-header').offset().top - 120);
    this.$goToPageInput.attr({'placeholder': inputVal, 'data-active-page': inputVal});
    this.switchPage(parseInt(inputVal, 10) - 1);
    this.handleClick(true);
};



DazProductList.prototype.handleShowHideBackToTop = function() {
    const scrollBuffer = 250;

    if (window.scrollY > $('#collapsible-product-display-container').offset().top + scrollBuffer) {
        if (!this.$controlsContainer.find('.back_to_top').is(':visible')) {
            this.$controlsContainer.find('.back_to_top').fadeIn(this.paginationTransitionSpd);
        }
    } else {
        if (this.$controlsContainer.find('.back_to_top').is(':visible')) {
            this.$controlsContainer.find('.back_to_top').fadeOut(this.paginationTransitionSpd);
        }
    }
}

DazProductList.prototype.validatePagenumInput = function(inputVal) {
    if (inputVal === '' || inputVal == null) {
        return false;
    }

    const pageNum = Number(inputVal);

    if (
        !Number.isInteger(pageNum)
        || pageNum < 1
        || pageNum > this.getPageCount()
    ) {
        return false;
    }

    return true;
};

DazProductList.prototype.handlePaginationClick = function(event) {
    this.handlePaginationMaybeScroll(event);

    var selectedPage = $(event.target).attr('data-pagenum');

    if (selectedPage != null) {
        this.switchPage(parseInt(selectedPage,10));
        this.handleClick(true);
    }
};

DazProductList.prototype.changePageSize = function(event) {
    // Need to toggle all the page size things to the same, but don't want to retrigger this event
    $('.pagesize').off('change');

    var newPageSize = $(event.currentTarget).val();

    $('.pagesize').val(newPageSize);

    newPageSize = parseInt(newPageSize, 10);

    daz.api.storagePut('catalog_pageSize', newPageSize);

    $('.pagesize').blur();
    $('.pagesize').on('change', $.proxy(this.changePageSize, this));
    this.buildPagination();

    this.pageSize = newPageSize;
    if (this.pageSize == -1) {
        this.infiniteScroll = true;
        this.reset();
        this.buildPagination();
        this.handleScroll();
    } else {
        this.infiniteScroll = false;
        this.switchPage(0);
    }

    this.applyHiddenFiltersCss()
};

DazProductList.prototype.buildPagination = function() {
    if (this.infiniteScroll) {
        $('.pagination_container').hide();
        return;
    }

    var maxPages = Math.ceil(this.ordered.length / this.pageSize);
    this.pageCount = maxPages;
    this.lastPagenum = maxPages;
    var displayItems = [];
    if (maxPages < 7) {
        for (var i = 0; i < maxPages; i++) {
            displayItems.push(i);
        }
    } else if (this.currPage < 4) {
        for (var i = 0; i < 5; i++ ) {
            displayItems.push(i);
        }
        displayItems.push(-1);
        displayItems.push(maxPages-1);
    } else if (this.currPage > (maxPages - 4)) {
        displayItems.push(0);
        displayItems.push(-1);
        for (var i = maxPages - 4; i < maxPages; i++) {
            displayItems.push(i);
        }
    } else {
        displayItems.push(0);
        displayItems.push(-1);
        displayItems.push(this.currPage - 1);
        displayItems.push(this.currPage);
        displayItems.push(this.currPage + 1);
        displayItems.push(-1);
        displayItems.push(maxPages-1);
    }

    var html = '';
    for ( var i = 0; i < displayItems.length; i++) {
        if (displayItems[i] == -1) {
            html += '<span class="pagination_blank">...</span>';
        } else {
            var extraClass = '';
            if (displayItems[i] == this.currPage) {
                extraClass = ' active';
            }
            html += '<a class="pagination_page button '+extraClass+'" data-pagenum='+displayItems[i]+'>'+(displayItems[i]+1)+'</a>';
        }
    }
    $('.pagination').html(html);
    if (this.currPage == 0) {
        $('.pagination_container .prev').addClass('disabled');
    } else {
        $('.pagination_container .prev').removeClass('disabled');
    }

    if (this.currPage >= maxPages - 1) {
        $('.pagination_container .next').addClass('disabled');
    } else {
        $('.pagination_container .next').removeClass('disabled');
    }

    $('.pagination_container').show();

    this.syncGoToPageInput();
};

/*** Catalog display functions ***/
DazProductList.prototype.showCatalog = function(ignore, data, isCache) {
    if (this.categoryId != null) {
        // Load the full category with matureFilter=false (special case for the catalog; filtering applies afterward)
        // This allows a user to start with the mature filter enabled, then uncheck the filter to see mature content
        const pm = {};
        const initialList = this.recursiveProducts(this.categoryId, pm)
        this.productList = daz.filter.filterProducts(initialList, {category: [this.categoryId]});
    }

    var direction = 'ASC';
    if (this.sortOrderSettings[1] == 1) {
        // Reverse sort
        direction = 'DESC';
    }
    if (this.productCount === -1) {
        this.productCount = this.productList.length;
    }
    this.ordered = daz.filter.sortProducts(this.productList, this.sortOrderSettings[0], direction);

    this.hideLoading();
    window.setTimeout($.proxy(this.setupFilters,this),1);

    var onlyPlat = daz.api.sessionStorageGet('platClubOnly');
    if (onlyPlat && !this.filterSettings.platClub) {
        this.platClubHandleClick();
    }
    var showOwned = daz.api.sessionStorageGet('showOwned');
    if (showOwned && this.filterSettings.owned) {
        // this.ownedHandleClick();
    }
    var onlyBundle = daz.api.sessionStorageGet('bundleOnly');
    if (onlyBundle && !this.filterSettings.bundle) {
        this.bundleHandleClick();
    }

    var onlyWishlist = daz.api.sessionStorageGet('wishListOnly');
    if (onlyWishlist && !this.filterSettings.inWishlist) {
        this.wishlistHandleClick();
    }

    if (this.urlHash.fparam('filtered') == '1'
        || this.urlHash.fparam('order') != undefined) {
        this.loadFilterFromHash();
    }

    if (daz.filter && daz.filter.seedFileFormatFilterSettings) {
        daz.filter.seedFileFormatFilterSettings(this.filterSettings);
    }

    this.applyFilters(false);

    var topLeft = null;
    if (this.infiniteScroll ) {
        if (this.urlHash.param('p') && !this.urlHash.fparam('index')) {
            // We are coming from someplace that is paginated
            // but don't have a different scroll location in the url
            topLeft = (parseInt(this.urlHash.param('p'),10)-1)*this.pageSize;
        }
        if (this.urlHash.fparam('index')) {
            topLeft = parseInt(this.urlHash.fparam('index'),10);
        }
        if (isNaN(topLeft)) {
            topLeft = null;
        }

        if (topLeft != null && this.ordered[topLeft]) {
            // Time to backfill
            this.addPlaceholders(topLeft - this.orderedStart + 10);
            window.setTimeout($.proxy(function() {this.scrollToIndex(topLeft); },this),100);
        } else {
            this.reuseExistingSlabs(-1);
            this.hideLoading();
        }
    } else {
        var pageNum = 0;
        if (this.urlHash.param('p')) {
            pageNum = parseInt(this.urlHash.param('p'),10)-1;
        }
        if (this.urlHash.fparam('p')) {
            pageNum = parseInt(this.urlHash.fparam('p'),10)-1;
        }

        this.switchPage(pageNum);
        this.buildPagination();
        this.hideLoading();
    }

    $(window).on('scroll', $.proxy(this.handleScroll, this));

    window.setTimeout($.proxy(this.handleScroll,this), 1);

    this.catalogReady = true;
};

DazProductList.prototype.scrollToIndex = function(index) {
    var elem = $('#product-'+this.ordered[index]);
    if (elem[0] && elem.offset().top) {
        var scrollFunc = function() {
            if (window.scrollY < 1) {
                window.setTimeout(scrollFunc,200);
            }
            document.body.scrollTop = elem.offset().top;
        };
        window.setTimeout(scrollFunc, 200);
        window.setTimeout(scrollFunc, 400);
        this.hideLoading();
    } else {
        window.setTimeout($.proxy(function() {this.scrollToIndex(index); },this),50);
    }
};

DazProductList.prototype.reuseExistingSlabs = function(maxSlabs) {
    this.listElem.html('');
    return 0;
    // For someday in the future.
    /*
    var rawElem = this.listElem[0];
    var existingList = [];

    for (var i = 0; i < rawElem.children.length; i++) {
        var productId = $(rawElem.children[i]).attr('data-productid');
        existingList.push(productId);
        if (daz.filter.productIsInCart(productId)) {
            $('#product-'+productId).find('button.btn-cart').css('display','none');
            $('#product-'+productId).find('button.btn-in-cart').css('display','block');
        }
    }


    var elem = null;

    for (var i = 0; i < this.ordered.length; i++) {
        if (document.getElementById('product-'+this.ordered[i])) {
            // Element already exists
            continue;
        }

        if (this.orderedStart === null) {
            // We got to the end of the products on the page, fetch the new
            // slabs starting here
            this.orderedStart = i;
        }
    }
    */
};

DazProductList.prototype.fillVisibleSlabs = function(forceReload) {
    var windowTop = $(window).scrollTop();
    var visibleTop = windowTop + 50;
    var oldTopLeft = this.topLeftIndex;
    var height = $(window).height();
    var windowBot = windowTop + height + 250;
    var pos = null;

    if (this.scrollTimeout) {
        window.clearTimeout(this.scrollTimeout);
        this.scrollTimeout = null;
    }

    if (this.topLeftIndex == null) {
        this.oldTopLeft = -1;
        this.topLeftIndex = 0;
        forceReload = true;
    }

    // Locate the top-left element
    // Start at the last indexed element and go back until we are off the screen
    // (or at the first element)
    while (this.topLeftIndex > 0) {
        pos = this.getPosition(this.ordered[this.topLeftIndex]);
        if ( pos.top && pos.top < visibleTop ) {
            break;
        }

        this.topLeftIndex--;
    }

    // After we have gone off the screen, go forward until we are back on the screen
    // that element is ours.
    while (this.topLeftIndex < this.ordered.length) {
        pos = this.getPosition(this.ordered[this.topLeftIndex]);
        if ( pos.top && pos.top > visibleTop ) {
            break;
        }

        this.topLeftIndex++;
    }

    if (DazProductSlab.requestCount > 50 ) {
        // Give the server a bit of a breather
        if (!this.scrollTimeout) {
            this.scrollTimeout = window.setTimeout($.proxy(function() {this.fillVisibleSlabs(true);}, this), 250);
        }
        return;
    }

    if (true) {
        // Fill in some surrounding elements
        var i = this.topLeftIndex;

        var loadSlabs = {};

        while (i < this.ordered.length) {
            pos = this.getPosition(this.ordered[i]);
            if ( pos.top && pos.top > windowBot) {
                // This is no longer on the screen
                break;
            }

            if (pos.placeholder) {
                loadSlabs[this.ordered[i]] = true;
                this.positionCache[this.ordered[i]].placeholder = false;
            }
            i++;
        }

        var elemCount = 0;
        // Populate the next elements off the edge of the screen
        while (elemCount < 11 && i < this.ordered.length) {
            pos = this.getPosition(this.ordered[i]);

            if (pos.placeholder) {
                loadSlabs[this.ordered[i]] = true;
                this.positionCache[this.ordered[i]].placeholder = false;
            }

            elemCount++;
            i++;
        }

        // Populate the previous elements off the top
        elemCount = 0;
        i = this.topLeftIndex - 1;
        while (elemCount < 11 && i > -1) {
            pos = this.getPosition(this.ordered[i]);

            if (pos.placeholder) {
                loadSlabs[this.ordered[i]] = true;
                this.positionCache[this.ordered[i]].placeholder = false;
            }

            elemCount++;
            i--;
        }

        this.loadProducts(loadSlabs);
    }
};

DazProductList.prototype.loadProducts = function(productIds) {
    for (i in productIds) {
        var elemSelector = '#product-'+i;
        var slab = new DazProductSlab({id: i}, this.slab, elemSelector);
        slab.load();
    }
};

DazProductList.prototype.handleScroll = function() {
    if (!this.scrollTimeout) {
        this.scrollTimeout = window.setTimeout($.proxy(this.fillVisibleSlabs, this), 50);
    }

    if (!this.infiniteScroll) {
        return;
    }

    if (this.orderedStart < this.ordered.length) {
        var offset = this.listElem.offset();
        var windowTop = $(window).scrollTop();
        var height = $(window).height();
        var windowBot = windowTop + height;


        if ((offset.top+this.listElem.height()-windowBot) < (height * 2)) {
            this.addPlaceholders(20);
        }
    }
};

DazProductList.prototype.handleClick = function(event) {
    var shouldProcess = false;
    if (event === true) {
        shouldProcess = true;
    } else {
        var target = $(event.target);
        if (target.closest('a') || target.closest('button')) {
            shouldProcess = true;
        }
    }
    if (!shouldProcess) {
        return;
    }

    var extraHash = [];
    var hasFilter = false;
    if (this.infiniteScroll) {
        extraHash.push('index='+this.topLeftIndex);
    } else {
        if (this.currPage > 0) {
            extraHash.push('p='+(this.currPage+1));
        }
    }

    for (var filterType in this.filterSettings) {
        if (filterType == 'owned' || filterType == 'platClub') {
            continue;
        }
        if (filterType == 'price') {
            if (this.isPriceFilterActive()) {
                hasFilter = true;
                extraHash.push('filter_price=' + this.filterSettings.price.join('^'));
            }
            continue;
        }
        if (this.filterSettings[filterType].length < 1) {
            continue;
        }
        hasFilter = true;
        if (this.filterSettings[filterType]) {
            extraHash.push('filter_'+filterType+'='+this.filterSettings[filterType].join('^'));
        }
    }

    if (this.sortOrderSettings[0] != 'date' || this.sortOrderSettings[1] != 1) {
        hasFilter = true;
        extraHash.push('order='+this.sortOrderSettings[0]+'^'+this.sortOrderSettings[1]);
    }

    if (hasFilter) {
        extraHash.push('filtered=1');
    }

    this.changingHash = true;
    var newHash = extraHash.join('&');
    if (history && history.pushState) {
        history.pushState(null, null, '#'+newHash);
    } else {
        window.location.hash = newHash;
    }
    this.changingHash = false;
};

DazProductList.prototype.handleOrderClick = function(event) {
    if (event.target.tagName != 'LI') {
        return;
    }

    var elem = $(event.target);
    // Thanks foundation for not having a better way to close dropdowns.
    var parentElem = $('div.sort_container');
    parentElem.click();
    parentElem.find('.location').html(elem.text());

    this.sortOrderSettings = [elem.attr('data-sortdata') , elem.attr('data-sortdir')];
    this.handleClick(true);
    this.applyFilters(true);
};

DazProductList.prototype.handleSortBy = function(event) {
    let selectedOption = $(event.target).find('option:selected');
    this.sortOrderSettings = [selectedOption.attr('data-sortdata') , selectedOption.attr('data-sortdir')];
    this.applyFilters(true);
};

DazProductList.prototype.handleResize = function() {
    this.positionCache = {};

    window.setTimeout($.proxy(this.handleScroll, this), 1);
};

DazProductList.prototype.getPosition = function(productId) {
    if (!this.positionCache[productId]) {
        var elem = $('#product-'+productId);
        var pos = elem.offset();
        if (!elem || !pos) {
            return {'top':null, 'left':null, 'bottom': null, 'right': null};
        }
        pos.bottom = pos.top + elem.height();
        pos.right = pos.left + elem.width();
        pos.placeholder = true;
        this.positionCache[productId] = pos;
    }

    return this.positionCache[productId];
};

DazProductList.prototype.addPlaceholders = function(addCount) {
    var addedElems = 0;

    for (var i = this.orderedStart; i < this.ordered.length && (addedElems < addCount); i++) {
        if (document.getElementById('product-'+this.ordered[i])) {
            // Element already exists
            // This really shouldn't ever happen
            continue;
        }

        var newElem = $(this.slabholder.render({id: this.ordered[i]}))[0];
        this.listElem[0].appendChild(newElem);
        addedElems++;
    }

    this.orderedStart = i;

    if ( this.orderedStart < this.ordered.length ) {
        window.setTimeout($.proxy(this.handleScroll,this),1);
    }
};

DazProductList.prototype.recursiveProducts = function(catId, productMap = {}) {
    let cat = daz.filter.rawCategories[catId]

    if (!cat) return []
    let catProducts = cat?.products || []
    for (let i = 0; i < catProducts.length; i++) {
        if (!productMap[catProducts[i]]) {
            if (daz.filter.sorts.price[catProducts[i]] === undefined) {
                continue;
            }
            productMap[catProducts[i]] = true;
        }
    }

    if (!cat.children || !cat.children.length) {
        return Object.keys(productMap)
    }

    for (var i = 0; i < cat.children.length; i++) {
        this.recursiveProducts(cat.children[i], productMap)
    }
    return Object.keys(productMap)
}
